import React from 'react';
import { Button, NumberBox, Form, TextBox } from 'devextreme-react';
import { GroupItem, SimpleItem } from 'devextreme-react/form';
import { formatDate } from '../utils/stopwatchUtils';
import {
    hasStopwatchState,
    hasSavedSessions
} from '../persistence';
import { Item, Toolbar } from 'devextreme-react/toolbar';
import { confirm } from 'devextreme/ui/dialog';

const StopwatchSetup = ({
    lanes,
    setLanes,
    rows,
    setRows,
    sessionName,
    setSessionName,
    savedSessions,
    currentSessionId,
    onInitializeGrid,
    onLoadSession,
    onDeleteSession,
    onClearSavedState,
    onLoadTemporaryState,
    navigate
}) => {
    return (
        <div className="view-wrapper view-wrapper-stopwatch-setup">
            <Toolbar className='toolbar-details theme-dependent'>
                <Item location='before'>
                    <Button icon='arrowleft' stylingMode='text' onClick={function(e){navigate(-1)}} />
                </Item>
                <Item location='before' text="Stoppuhren" />

            </Toolbar>
        


                    <div className="setup-card">
                        <h3>Neue Sitzung erstellen</h3>

                        <Form colCount={2}>
                            <GroupItem caption="Sitzungsname">
                                <SimpleItem>
                                    <TextBox
                                        value={sessionName}
                                        onValueChanged={(e) => setSessionName(e.value)}
                                        placeholder="z.B. Training Gruppe A, Wettkampf, Techniktraining..."
                                    />


                                </SimpleItem>
                            </GroupItem>

                            <GroupItem caption="Konfiguration" colCount={2}>
                                <SimpleItem>
                                    <NumberBox
                                        label="Anzahl Bahnen"
                                        value={lanes}
                                        onValueChanged={(e) => setLanes(e.value)}
                                        min={1}
                                        max={10}
                                        showSpinButtons
                                    />
                                </SimpleItem>
                                <SimpleItem>
                                    <NumberBox
                                        label="Anzahl Reihen"
                                        value={rows}
                                        onValueChanged={(e) => setRows(e.value)}
                                        min={1}
                                        max={20}
                                        showSpinButtons
                                    />
                                </SimpleItem>
                            </GroupItem>

                            <SimpleItem>
                                <Button
                                    text="Neue Sitzung erstellen"
                                    type="success"
                                    onClick={onInitializeGrid}
                                    width="200px"
                                    disabled={!sessionName.trim()}
                                />
                            </SimpleItem>
                        </Form>
                    </div>

                    {hasSavedSessions() && (
                        <div className="setup-card">
                            <h3>Vorhandene Sitzungen ({savedSessions.length})</h3>
                            <p>Wechseln Sie zu einer bereits vorhandenen Sitzung.</p>
                            <div className="saved-sessions-preview">
                                {savedSessions.slice(0, 8).map((session) => (
                                    <div key={session.id} className="session-preview-item">
                                        <div className="session-preview-info">
                                            <div className="session-preview-name">
                                                {session.name}
                                                {session.id === currentSessionId && (
                                                    <span className="current-session-badge">Aktuell</span>
                                                )}
                                            </div>
                                            <div className="session-preview-details">
                                                {formatDate(session.lastModified)} -
                                                {session.state && ` ${session.state.lanes}×${session.state.rows} Grid - ${Object.keys(session.state.recordedTimes || {}).length} Zeiten`}
                                            </div>
                                        </div>
                                        <div className="session-preview-actions">
                                            <Button
                                                text="Laden"
                                                type="normal"
                                                onClick={() => onLoadSession(session.id)}
                                              
                                            />
                                            <Button
                                                text="Löschen"
                                                type="danger"
                                                onClick={() => {
                                                    confirm(`Möchten Sie die Sitzung "${session.name}" wirklich löschen?`,'Sitzung löschen').then((result) => {
                                                        if (result) {
                                                            onDeleteSession(session.id);
                                                        }
                                                    });
                                                }}
                                              
                                            />
                                        </div>
                                    </div>
                                ))}

                                {savedSessions.length > 8 && (
                                    <div className="more-sessions">
                                        <Button
                                            text={`Alle ${savedSessions.length} Sitzungen verwalten`}
                                            type="default"
                                            onClick={() => {/* Show load session dialog */ }}
                                            width="100%"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}

                   
                </div>
     
    );
};

export default StopwatchSetup;
